import "./index.css";
import { Dashboard } from "@/components/Dashboard";

export function App() {
	return <Dashboard />;
}

export default App;
